import { render } from "./Forgot.vue?vue&type=template&id=498bb2ce&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"

import "./Forgot.vue?vue&type=style&index=0&id=498bb2ce&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498bb2ce"]])

export default __exports__